<template>
  <div id="modals">
    <!-- TODO: via loop -->
    <!-- TODO: Was kann raus? -->
    <TimeCommitmentSettingsModal ref="timecommitment" />
    <ConnectionSettingsModal ref="connection" />
    <!-- TODO: move to prompt-->
    <GoalSelectionModal ref="goalselection" />
    <HelpKeyboardShortcuts ref="help" />
    <IdolSelectionModal ref="idolselection" />
    <TimePreferencesModal ref="timepref" />
    <BackgroundSettingsModal ref="background" />
    <InitialSetupWizard ref="init-setup" />
    <GoalConfigModal ref="goal" />
    <GoalCategoryConfigModal ref="goal-category" />
    <EffortConfigModal ref="effort" :is-nested="isNested.effortConfig" />
    <TaskConfigModal ref="task" />
    <GoalVisualSettingsModal ref="goal-visual"/>
    <TextVisualSettingsModal ref="text-visual" />
    <VisionboardSettingsModal ref="visionboard-settings" />
    <SessionDetailsModal ref="session" />
    <TimeslotCollectionConfigModal ref="timeslot-collection" />
    <TimeslotCollectionStatsModal ref="timeslot-collection-stats" />
    <TimeslotDetailsModal ref="timeslot-details" />
    <Bugtracker ref="bugtracker" />
  </div>
</template>

<script>
// TODO: commitment -> effort - rename all

import TimeCommitmentSettingsModal from './TimeCommitmentSettingsModal';
import ConnectionSettingsModal from './ConnectionSettingsModal';
import GoalSelectionModal from './GoalSelectionModal';
import HelpKeyboardShortcuts from './HelpKeyboardShortcuts';
import IdolSelectionModal from './IdolSelectionModal';
import TimePreferencesModal from './TimePreferencesModal';
import BackgroundSettingsModal from './BackgroundSettingsModal';

import InitialSetupWizard from './InitialSetupWizard';
import GoalConfigModal from './GoalConfigModal'
import GoalCategoryConfigModal from './GoalCategoryConfigModal';
import EffortConfigModal from './EffortConfigModal'
import TaskConfigModal from './TaskConfigModal'
// TODO: Event modal

import GoalVisualSettingsModal from './GoalVisualSettingsModal'
import TextVisualSettingsModal from './TextVisualSettingsModal'
import VisionboardSettingsModal from './VisionboardSettingsModal'
import SessionDetailsModal from './SessionDetailsModal'
import TimeslotCollectionConfigModal from './TimeslotCollectionConfigModal'
import TimeslotCollectionStatsModal from './TimeslotCollectionStatsModal'
import TimeslotDetailsModal from './TimeslotDetailsModal'
import Bugtracker from './Bugtracker'

// TODO: require.context

/* Usage:
   ========

   this.$root.showModal('effort', data, false)
    .then(({ action, data }) => {
     if ( action === 'save' ) {
       console.log(data)
     }
   })

*/

export default {
  data: () => ({
    isNested: {
      'effortConfig': false
    },
    available: [
      "timecommitment",
      "connection",
      "goalselection",
      "help",
      "idolselection",
      "timepref",
      "background",
      "goal",
      "effort",
      "commitment-wizard",
      "task",
      "goal-category",
      "goal-visual",
      "text-visual",
      "visionboard-settings",
      "session",
      "timeslot-collection",
      "timeslot-collection-stats",
      "timeslot-details",
      "bugtracker",
      "init-setup",
    ]
  }),
  created() {
    this.$root.registerModalManager(this);
  },
  methods: {
    show( modalName, data, isNested, isUpdate ) {
      return new Promise((resolve, reject) => {

        if ( isNested !== undefined ) {
          this.isNested[ modalName ] = isNested;
        }

        if ( !( modalName in this.$refs ) ) {
          console.warn('[' + modalName + '] Modal not found!');
          return
        }

        let modal = this.$refs[ modalName ];
        const EVENT_LIST = ['close', 'save', 'saved', 'delete', 'deleted', 'export'];

        function detachAllEventListeners() {
          /* not really necessary, since we do it before open, but still feels
             better to clean up after modal is closed */
          EVENT_LIST.forEach(eventName => {
            modal.$off(eventName)
          })
        };

        EVENT_LIST.forEach(eventName => {
          /* Remove previous listeners */
          modal.$off(eventName);
          modal.$once(eventName, (data) => {
            resolve({ action: eventName, data: data });
            detachAllEventListeners();
          })
        });

        let funcList = [
          ( 'showModal' in modal ) ? 'showModal' : undefined,
          ( 'showNewModal' in modal ) ? 'showNewModal' : undefined,
          ( 'showUpdateModal' in modal ) ? 'showUpdateModal' : undefined,
        ].filter(item => item);

        let funcName;
        if ( isUpdate === undefined ) {
          funcName = 'showModal';
        } else if ( isUpdate === false ) {
          funcName = 'showNewModal';
        } else if ( isUpdate === true ) {
          funcName = 'showUpdateModal';
        }

        // console.log("funcList", funcList, "funcName", funcName);
        if ( funcList.includes(funcName) ) {
          modal[funcName](data);
        } else {
          /* Handle missing function */
          console.warn('[' + modalName + '] Function ' + funcName + ' does not exist. Did you mean ' + funcList.join(','));
        }
      });
    },
  },
  components: {
    TimeCommitmentSettingsModal,
    ConnectionSettingsModal,
    GoalSelectionModal,
    HelpKeyboardShortcuts,
    IdolSelectionModal,
    TimePreferencesModal,
    BackgroundSettingsModal,
    GoalConfigModal,
    GoalCategoryConfigModal,
    GoalVisualSettingsModal,
    EffortConfigModal,
    TaskConfigModal,
    TextVisualSettingsModal,
    VisionboardSettingsModal,
    SessionDetailsModal,
    TimeslotCollectionConfigModal,
    TimeslotCollectionStatsModal,
    TimeslotDetailsModal,
    Bugtracker,
    InitialSetupWizard,
  }
}
</script>
